import React from 'react';
import { Box } from '@mui/material';

const InsertionIndicator = ({ color = '#2196f3', isVisible = false }) => {
  if (!isVisible) return null;

  return (
    <Box
      sx={{
        height: '4px',
        backgroundColor: color,
        borderRadius: '2px',
        margin: '4px 0',
        position: 'relative',
        animation: 'pulse 1s ease-in-out infinite',
        boxShadow: `0 0 10px ${color}50`,
        '&::before': {
          content: '""',
          position: 'absolute',
          left: '-6px',
          top: '-4px',
          width: '12px',
          height: '12px',
          backgroundColor: color,
          borderRadius: '50%',
          boxShadow: `0 0 8px ${color}60`,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          right: '-6px',
          top: '-4px',
          width: '12px',
          height: '12px',
          backgroundColor: color,
          borderRadius: '50%',
          boxShadow: `0 0 8px ${color}60`,
        },
        '@keyframes pulse': {
          '0%, 100%': {
            opacity: 0.7,
            transform: 'scaleY(1)',
          },
          '50%': {
            opacity: 1,
            transform: 'scaleY(1.2)',
          },
        },
      }}
    />
  );
};

export default InsertionIndicator;
